import { render, staticRenderFns } from "./AcademicRecordItem.vue?vue&type=template&id=5f145c14&scoped=true&"
import script from "./AcademicRecordItem.vue?vue&type=script&lang=js&"
export * from "./AcademicRecordItem.vue?vue&type=script&lang=js&"
import style0 from "./AcademicRecordItem.vue?vue&type=style&index=0&id=5f145c14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f145c14",
  null
  
)

export default component.exports